<template lang="pug">
.sound-modal(@click.self="close")
  .win
    .win__content
      .title 音声をONにしましたか？
      .option
        .btn--red(@click="turnOn"): .btn__label しました
        .btn--orange(@click="turnOn"): .btn__label うん
    .win__close
</template>

<style lang="scss" scoped>
.sound-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(#000, 0.8);
  opacity: 1;
  transition: opacity 0.2s;
  &.v-enter,
  &.v-leave-to {
    opacity: 0;
  }
}

.win {
  position: relative;
  background-image: image-url("bg.gif");
  background-size: 200px 200px;
  width: (650px / 2);
}

.win__content {
  margin: 20px 0px;
}

.win__close {
  position: absolute;
  right: 0;
  bottom: 100%;
  margin-bottom: 16px;
  width: 20px;
  pointer-events: none;
  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: #fff;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
}

.title {
  margin-top: 70px;
  margin-bottom: 50px;
  font-size: 20px;
  font-family: sans-serif;
  font-style: italic;
  font-weight: bold;
  text-align: center;
}

.btn {
  text-align: center;
  width: (466px / 2);
  margin: auto;
  margin-bottom: 10px;
  padding: 12px 0px;
  border-radius: 15px;
  &:last-child {
    margin-bottom: 0;
  }
}
.btn--red {
  @extend .btn;
  background-color: #f00;
}
.btn--orange {
  @extend .btn;
  background-color: #f6b37f;
}

.btn__label {
  @include font-mincho;
  color: #00f;
  font-weight: 900;
  font-size: 20px;
  line-height: 1;
  text-decoration: underline;
  transform: scaleX(2.5) translateX(10px);
}
</style>

<script>
import { mapActions } from "vuex";

export default {
  name: "sound-modal",
  methods: {
    ...mapActions(["turnOnSound"]),
    close() {
      this.$emit("close");
    },
    turnOn() {
      gtag("event", "goout", {
        event_category: "sound-on"
      });
      this.turnOnSound();
      this.close();
    }
  }
};
</script>
